import { render } from "./ModalFairInfo.vue?vue&type=template&id=53d260cf&scoped=true"
import script from "./ModalFairInfo.vue?vue&type=script&lang=js"
export * from "./ModalFairInfo.vue?vue&type=script&lang=js"

import "./ModalFairInfo.vue?vue&type=style&index=0&id=53d260cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d260cf"]])

export default __exports__